import React from 'react'
import styles from './stars.module.sass'

const STAR = 'M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z'
const FIVE = [0, 1, 2, 3, 4]

type Props = {
  // 0-5; a part star fills in proportion.
  rating: number
  size?: number
}

// Five stars filled to the rating, read out as "4.5 out of 5 stars".
export const Stars = ({ rating, size = 22 }: Props) => {
  const stars = FIVE.map((index) => <Star key={index} fill={Math.max(0, Math.min(1, rating - index))} size={size} />)

  return (
    <span className={styles.stars} role="img" aria-label={`${rating.toFixed(1)} out of 5 stars`}>
      {stars}
    </span>
  )
}

const Star = ({ fill, size }: { fill: number; size: number }) => (
  <span className={styles.star} style={{ height: size, width: size }}>
    <StarShape className={styles.empty} />
    <span className={styles.fill} style={{ width: `${fill * 100}%` }}>
      <StarShape className={styles.full} size={size} />
    </span>
  </span>
)

const StarShape = ({ className, size }: { className: string; size?: number }) => (
  <svg className={className} viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path d={STAR} />
  </svg>
)
